// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608281504/js/" + chunkId + "." + {"44":"d0908b57","225":"08afc553","481":"3ee3b119","486":"53b1a32e","770":"1056765e"}[chunkId] + ".0.09003254243343461.chunk.js";
};